import * as React from "react";
import { Chip, SxProps, Typography } from "@mui/material";

export interface AdvancedQueryTagProps {
  sx?: SxProps;
  tagName?: string;
  start: string;
  end: string;
  condition: string;
  color: "success" | "error";
}

const AdvancedQueryTag: React.FC<AdvancedQueryTagProps> = (props) => {
  const { start, end, condition, color, tagName, ...otherProps } = props;
  return (
    <Chip
      {...otherProps}
      variant="tag"
      label={
        <>
          {start}&nbsp;
          <Typography component="span" color={`${color}.main`}>
            {condition}&nbsp;
          </Typography>
          {end}
        </>
      }
    />
  );
};

export default AdvancedQueryTag;
